import { render } from "./ClosetWrapperView.vue?vue&type=template&id=7bfe538e&ts=true"
import script from "./ClosetWrapperView.vue?vue&type=script&lang=ts"
export * from "./ClosetWrapperView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__